import { useCallback } from 'react';
import { ToastVariants } from '@dotcom/crown-ui';
import { useTranslation } from 'react-i18next';
import { useUIStore } from '../../../stores/ui';
import { isCurrentEditHistorySession, useEditHistorySessionOwner } from '../edit-history-store';

export const useHistoryTransactionErrorToast = (): (() => void) => {
  const openToaster = useUIStore((state) => state.openToaster);
  const owner = useEditHistorySessionOwner();
  const { t } = useTranslation();

  return useCallback(() => {
    if (!isCurrentEditHistorySession(owner)) return;
    openToaster(
      {
        title: t('cardEditor.historyTransactionFailedTitle'),
        children: t('cardEditor.historyTransactionFailed'),
        variant: ToastVariants.Error,
      },
      owner ?? undefined,
    );
  }, [openToaster, owner, t]);
};
